/**
 * Tab controller 
 * @author Erik Bánhalmi 2017.05.02.
 */ 
import newsListTemplate from './m06-news-list-component.pug';

const MODULE_NAME = 'newsList';
class NewsListController {
	constructor() {
		'ngInject';
	}
}

export default angular.module(MODULE_NAME, [])
	.component('newsList', {
		transclude: true,
		template: newsListTemplate(),
		controller: NewsListController
	}).name;



// WEBPACK FOOTER //
// ../source/modules/M06-news-list/M06-news-list.js